// extracted by mini-css-extract-plugin
export var wordContainer = "_nl-0";